import styled from "styled-components";


export default styled.div`
&{
  display: contents;
}

.main{
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  align-items: stretch;

}
.div-image{
  margin-top:5px;
  .image {
    position:relative;
    img {
      max-width: 150px;
      min-width: 75px;
      max-height:130px;
      opacity:1;
      right:0;
    }
    .img-opacity{
      opacity:0.2;
    }
    #remove {
      position:absolute;
      height:30px;
      width:30px;
      margin:0px;
      top:0px;
      right:0px;
      z-index:2;
      background-image: url(${process.env.PUBLIC_URL + "/icon-x.png"});
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius:50%;
      #textRemove {
        position: absolute;
        width:150px;
        height:30px;
        top:0px;
        left:35px;
        text-align:center;
        background-color:${props => props.theme.colors.primary};
        border-radius: 5px;
        padding-top:5px;
        margin-bottom:10px;
      }
    }
  }
}


#textRemove{
  display: none;
}
#remove:hover #textRemove{
  display:block;
}
.removeLabel{
  display: flex;
  justify-content: flex-end;
  color: red;
  width:200px;
  font-size:12px;
}
`;
